import {
    VaultPasswordAddEdit,
    IVaultPasswordPolicyRequirements,
    ICustomAttribute,
    IUserCustomAttribute,
    TranslationsTypes,
    TenantTypes
} from '@app/models';
import {
    availableAttributes, MODULE_NAME,
    PasswordReportsType, UserReportsType,
    VaultReportsType
} from '@app/pages/ssoManager/addEditApplication.enums';

export const USUrl: string = 'my.passly.com';
export const defaultOrgId: string = '00000000-0000-0000-0000-000000000000';
export const defaultAppId: string = '00000000-0000-0000-0000-000000000000';
export const emptyGuid: string = '00000000-0000-0000-0000-000000000000';
export const displayName: string = 'DisplayName';
export const nameConst: string = 'Name';
export const homeRealm: string = 'HomeRealm';
export const kaseyaProvisioningStateModel: string = 'Kaseya.AuthAnvil.Models.ProvisionState';
export const kaseyaWorkflowRequestStateModel: string = 'Kaseya.AuthAnvil.Models.WorkflowRequestState';
export const applicationAttributeModel: string = 'Kaseya.AuthAnvil.Models.ApplicationAttribute';
export const infiniteScrollItemsFetchLimit: number = 100;
export const fetchPoliciesSelectLimit: number = 25;
export const dialogComponentsListData: number = 100;
export const u2fEnabledAttributeName: string = 'u2fEnabled';
export const otpEnabledAttributeName: string = 'otpEnabled';

export const standardLicenseTypeName: string = 'Standard';
export const premiumLicenseTypeName: string = 'Premium';
export const provisioningStates: any[] = [
    { value: 'Active', label: 'PROVISION_STATE_ACTIVE', id: 3},
    { value: 'Created', label: 'PROVISION_STATE_CREATED', id: 1},
    { value: 'Disabled', label: 'PROVISION_STATE_INACTIVE', id: 4},
    { value: 'Provisioned', label: 'PROVISION_STATE_PROVISIONED', id: 2}
];

export const provisioningStatesSimple: any[] = [
    { value: 'Active', label: 'PROVISION_STATE_ACTIVE', id: 3 },
    { value: 'Disabled', label: 'PROVISION_STATE_INACTIVE', id: 4 },
];
export const provisioned: string = 'Provisioned';
export const created: string = 'Created';
export const archived: string = 'Archived';
export const active: string = 'Active';
export const disabled: string = 'Disabled';
export const syncIntervals: any[] = [
    { value: '60', label: 'SYNC_INTERVAL_HOURS_1' },
    { value: '240', label: 'SYNC_INTERVAL_HOURS_4' },
    { value: '480', label: 'SYNC_INTERVAL_HOURS_8' },
    { value: '720', label: 'SYNC_INTERVAL_HOURS_12' },
    { value: '1440', label: 'SYNC_INTERVAL_HOURS_24' }
];
export const translationVariable: string = '||0||';
export const digitRegex: RegExp = /[0-9]/;
export const searchMinimumLength: number = 3;
export const singleIPRegex: RegExp = /[0-9\.]/;
export const offlineLoginMin = 1;
export const offlineLoginMax = 42;
export const passwordFilter = 'Passwords';
export const folderFilter = 'Folders';

export const communityPassword = 'community';
export const snmpAuthPassword = 'snmpAuth';
export const snmpPrivacyPassword = 'snmpPrivacy';

// dom storage constants
export const expirationStorage = 'expiration';
export const onboardingStorage = 'onboarding';
export const signedInCookie = 'signed_in';
export const refreshTokenStorage = 'refresh_token';

// vault password constants
export const passwordDaysToExpire = 42;
export const AD_Windows = 'AD_Windows';
export const AuthAnvil_Related = 'AuthAnvil_Related';
export const General = 'General';
export const Linux = 'Linux';
export const Database = 'Database';
export const Network_Device = 'Network_Device';
export const Remote_Windows = 'Remote_Windows';
export const SNMP = 'SNMP';
export const SNMPV3 = 'SNMPV3';
export const SSH = 'SSH';
export const Standalone_Windows = 'Standalone_Windows';
export const Web = 'Web';

// Vault Password Property constants
export const DaysToExpire = 'DaysToExpire';
export const Username = 'Username';
export const Password = 'Password';
export const SnmpUser = 'SnmpUser';
export const SnmpAuthenticationPassword = 'SnmpAuthenticationPassword';
export const SnmpPrivacyPassword = 'SnmpPrivacyPassword';
export const SnmpCommunityString = 'SnmpCommunityString';
export const SnmpAgentPort = 'SnmpAgentPort';
export const Domain = 'Domain';
export const MachineName = 'MachineName';
export const WebsiteUrl = 'WebsiteUrl';
export const PasswordType = 'PasswordType';
export const DBType = 'DBType';
export const AgentProfileId = 'AgentProfileId';

export const passwordTypes: any[] = [
    { value: AD_Windows, label: 'VAULT_PASSWORD_TYPE_1' },
    { value: Database, label: 'VAULT_PASSWORD_TYPE_11' },
    { value: General, label: 'VAULT_PASSWORD_TYPE_3' },
    { value: Linux, label: 'VAULT_PASSWORD_TYPE_4' },
    { value: Network_Device, label: 'VAULT_PASSWORD_TYPE_5' },
    { value: AuthAnvil_Related, label: 'VAULT_PASSWORD_TYPE_2' },
    { value: Remote_Windows, label: 'VAULT_PASSWORD_TYPE_6' },
    { value: SNMP, label: 'VAULT_PASSWORD_TYPE_7' },
    { value: SNMPV3, label: 'VAULT_PASSWORD_TYPE_12' },
    { value: SSH, label: 'VAULT_PASSWORD_TYPE_8' },
    { value: Standalone_Windows, label: 'VAULT_PASSWORD_TYPE_9' },
    { value: Web, label: 'VAULT_PASSWORD_TYPE_10' }
];

export const passwordTypeDefault = 'General';

export const dbTypes = [
    { value: 'MSSQL', label: 'VAULT_PASSWORD_DB_TYPE_1' },
    { value: 'MySQL', label: 'VAULT_PASSWORD_DB_TYPE_2' },
    { value: 'PostgreSQL', label: 'VAULT_PASSWORD_DB_TYPE_3' },
    { value: 'Oracle', label: 'VAULT_PASSWORD_DB_TYPE_4' },
    { value: 'DB2', label: 'VAULT_PASSWORD_DB_TYPE_5' },
    { value: 'Other', label: 'VAULT_PASSWORD_DB_TYPE_6' }
];

export const dbTypeDefault = 'MSSQL';

export const authenticationProfiles = [
    { value: 'None', label: 'AUTHENTICATION_PROFILE_1' },
    { value: 'MD1', label: 'AUTHENTICATION_PROFILE_2' },
    { value: 'SHA1', label: 'AUTHENTICATION_PROFILE_3' }
];

export const encryptionProtocols = [
    { value: 'None', label: 'ENCRYPTION_PROTOCOL_1' },
    { value: 'DES', label: 'ENCRYPTION_PROTOCOL_2' },
    { value: 'AES', label: 'ENCRYPTION_PROTOCOL_3' }
];

export const defaultAuthenticationEncryption = 'None';

export const standardChars = '! # $ ^ * ( ) = _ +';
export const commonChars = '! @ # $ % ^ & * ( ) - = _ +';
export const extendedChars = '" ! @ # $ % ^ & * ( ) - = _ + [ ] { } | ; : , . / < > ?';

export const passwordComplexities: IVaultPasswordPolicyRequirements[] = [
    {
        value: 'Numeric',
        label: 'VAULT_PASSWORD_COMPLEXITY_1',
        MinimumLength: 4,
        MaximumLength: 8,
        SpecialCharactersUsed: '',
        OnlyNumbers: true,
        RequireDigits: true,
        RequireLowercase: false,
        RequireUppercase: false
    },
    {
        value: 'Simple',
        label: 'VAULT_PASSWORD_COMPLEXITY_2',
        MinimumLength: 6,
        MaximumLength: 12,
        SpecialCharactersUsed: '',
        OnlyNumbers: false,
        RequireDigits: true,
        RequireLowercase: true,
        RequireUppercase: true
    },
    {
        value: 'Simple_Standard_Chars',
        label: 'VAULT_PASSWORD_COMPLEXITY_3',
        MinimumLength: 6,
        MaximumLength: 12,
        SpecialCharactersUsed: standardChars,
        OnlyNumbers: false,
        RequireDigits: true,
        RequireLowercase: true,
        RequireUppercase: true
    },
    {
        value: 'Simple_Common_Chars',
        label: 'VAULT_PASSWORD_COMPLEXITY_4',
        MinimumLength: 6,
        MaximumLength: 12,
        SpecialCharactersUsed: commonChars,
        OnlyNumbers: false,
        RequireDigits: true,
        RequireLowercase: true,
        RequireUppercase: true
    },
    {
        value: 'Simple_Extended_Chars',
        label: 'VAULT_PASSWORD_COMPLEXITY_5',
        MinimumLength: 6,
        MaximumLength: 12,
        SpecialCharactersUsed: extendedChars,
        OnlyNumbers: false,
        RequireDigits: true,
        RequireLowercase: true,
        RequireUppercase: true
    },
    {
        value: 'Enhanced',
        label: 'VAULT_PASSWORD_COMPLEXITY_6',
        MinimumLength: 12,
        MaximumLength: 16,
        SpecialCharactersUsed: '',
        OnlyNumbers: false,
        RequireDigits: true,
        RequireLowercase: true,
        RequireUppercase: true
    },
    {
        value: 'Enhanced_Standard_Chars',
        label: 'VAULT_PASSWORD_COMPLEXITY_7',
        MinimumLength: 12,
        MaximumLength: 16,
        SpecialCharactersUsed: standardChars,
        OnlyNumbers: false,
        RequireDigits: true,
        RequireLowercase: true,
        RequireUppercase: true
    },
    {
        value: 'Enhanced_Common_Chars',
        label: 'VAULT_PASSWORD_COMPLEXITY_8',
        MinimumLength: 12,
        MaximumLength: 16,
        SpecialCharactersUsed: commonChars,
        OnlyNumbers: false,
        RequireDigits: true,
        RequireLowercase: true,
        RequireUppercase: true
    },
    {
        value: 'Enhanced_Extended_Chars',
        label: 'VAULT_PASSWORD_COMPLEXITY_9',
        MinimumLength: 12,
        MaximumLength: 16,
        SpecialCharactersUsed: extendedChars,
        OnlyNumbers: false,
        RequireDigits: true,
        RequireLowercase: true,
        RequireUppercase: true
    },
    {
        value: 'Strong_Standard_Chars',
        label: 'VAULT_PASSWORD_COMPLEXITY_10',
        MinimumLength: 16,
        MaximumLength: 64,
        SpecialCharactersUsed: standardChars,
        OnlyNumbers: false,
        RequireDigits: true,
        RequireLowercase: true,
        RequireUppercase: true
    },
    {
        value: 'Strong_Common_Chars',
        label: 'VAULT_PASSWORD_COMPLEXITY_11',
        MinimumLength: 16,
        MaximumLength: 64,
        SpecialCharactersUsed: commonChars,
        OnlyNumbers: false,
        RequireDigits: true,
        RequireLowercase: true,
        RequireUppercase: true
    },
    {
        value: 'Strong_Extended_Chars',
        label: 'VAULT_PASSWORD_COMPLEXITY_12',
        MinimumLength: 16,
        MaximumLength: 64,
        SpecialCharactersUsed: extendedChars,
        OnlyNumbers: false,
        RequireDigits: true,
        RequireLowercase: true,
        RequireUppercase: true
    },
    {
        value: 'Overly_Complex',
        label: 'VAULT_PASSWORD_COMPLEXITY_13',
        MinimumLength: 32,
        MaximumLength: 64,
        SpecialCharactersUsed: extendedChars,
        OnlyNumbers: false,
        RequireDigits: true,
        RequireLowercase: true,
        RequireUppercase: true
    }
];

export const defaultComplexity = 'default';

export const defaultNewVaultPassword: VaultPasswordAddEdit = {
    '@odata.type': 'Kaseya.AuthAnvil.Models.VaultPassword',
    VaultId: '',
    FolderId: '',
    DisplayName: '',
    Description: '',
    DaysToExpire: passwordDaysToExpire,
    ExpireAfterXMinutes: 0,
    EnableTrustedThirdPartyAccess: false,
    PasswordType: passwordTypeDefault,
    Username: '',
    Password: '',
    Notes: '',
    IgnoreVaultPasswordPolicy: false,
    Domain: '',
    MachineName: '',
    WebsiteUrl: '',
    Complexity: defaultComplexity,
    IconUrl: '',
    DBType: '',
    DBTypeOther: '',
    SnmpCommunityString: '',
    SnmpAgentPort: 0,
    SnmpAuthenticationProfile: '',
    SnmpEncryptionProtocol: '',
    SnmpUser: '',
    SnmpAuthenticationPassword: '',
    SnmpPrivacyPassword: '',
    AgentProfileId: 'none'
};

// Reset password options
export const RESET_OPTION_EMAIL_AND_SMS = '4';
export const RESET_OPTION_EMAIL = '3';
export const RESET_OPTION_SMS = '1';
export const RESET_OPTION_EMAIL_NONE = '400';

export const IndividualVaultType = 'Individual';

export const userDisplayNameRegex = '[\\p{L}\\w\\s_\'-]+';
export const emailInputRegex = new RegExp('^[_A-Za-z0-9-+]+(.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(.[A-Za-z0-9]+)*(.[A-Za-z]{2,})$');

export const PASSWORD_IMPORTER_HELP_URL = 'https://helpdesk.kaseya.com/hc/en-gb/articles/4407416850065';
export const userAttributesToHide = ['VaultImportEncryptionKey'];

export const RELEASE_DATE_JSON_URL = 'https://kaseya-whats-new.netlify.app/idagent/passly/index.json';
export const WHAT_NEW_BUTTON_URL = 'https://kaseya-whats-new.netlify.app/idagent/passly/';
const SUB_CLAIM = 'sub';
const NAMEID_CLAIM = 'nameid';
const PREFERRED_USERNAME_CLAIM = 'preferred_username';
const EMAIL_CLAIM = 'email';
const DN_CLAIM = 'dn';

export const USER_DISABLED_KASEYA_ONE_ERROR = 'k1_not_enabled_for_user' as TranslationsTypes;

export const RETURN_KASEYA_ONE_STATE = 'k1_login';
export const K1_LOGIN_CODE = 'k1_login_code';

export const Features = {
    Ausi: 'DirSync2',
    DarkwebUsersReports: 'DarkwebUsersReports',
};

export const reservedClaims: string[] = [
    SUB_CLAIM,
    'name',
    'given_name',
    'family_name',
    'middle_name',
    'nickname',
    PREFERRED_USERNAME_CLAIM,
    'profile',
    'picture',
    'website',
    EMAIL_CLAIM,
    'email_verified',
    'gender',
    'birthdate',
    'zoneinfo',
    'locale',
    'phone_number',
    'phone_number_verified',
    'address',
    'updated_at',
    NAMEID_CLAIM,
    DN_CLAIM,
    'iat',
    'kid',
    'iss',
    'aud',
    'exp',
    'nonce',
    'auth_time'
];

export const defaultClaimsMapping: ICustomAttribute[] = [
    { Emit: availableAttributes[3], Type: SUB_CLAIM, Properties: {} },
    { Emit: availableAttributes[0], Type: NAMEID_CLAIM, Properties: {} },
    { Emit: availableAttributes[0], Type: PREFERRED_USERNAME_CLAIM, Properties: {} },
    { Emit: availableAttributes[1], Type: EMAIL_CLAIM, Properties: {} },
    { Emit: availableAttributes[2], Type: DN_CLAIM, Properties: {} }
];

export const defaultUserClaimsMapping: IUserCustomAttribute = {
    [SUB_CLAIM]: availableAttributes[3],
    [NAMEID_CLAIM]: availableAttributes[0],
    [PREFERRED_USERNAME_CLAIM]: availableAttributes[0],
    [EMAIL_CLAIM]: availableAttributes[1],
    [DN_CLAIM]: availableAttributes[2]
};

export const generalFontSize: number = 14;
export const selectLineHeight: string = '16px';
export const idForK1App: string = '856abe83-65be-43e7-b69f-da5c06990449';

export const userReportsOptions: any[] = [
    { value: UserReportsType.userSee, label: 'REPORT_MANAGER_SELECT_1_ITEM_1' },
    { value: UserReportsType.userSeen, label: 'REPORT_MANAGER_SELECT_1_ITEM_2' },
    { value: UserReportsType.userStillKnow, label: 'REPORT_MANAGER_SELECT_1_ITEM_3'},
    { value: UserReportsType.userBeenDoingLately, label: 'REPORT_MANAGER_SELECT_1_ITEM_4' },
];

export const passwordReportsOptions: any[] = [
    { value: PasswordReportsType.aboutToExpire, label: 'REPORT_MANAGER_SELECT_2_ITEM_1' },
    { value: PasswordReportsType.outOfSync, label: 'REPORT_MANAGER_SELECT_2_ITEM_2' },
    { value: PasswordReportsType.notBeingSynced, label: 'REPORT_MANAGER_SELECT_2_ITEM_3'},
    { value: PasswordReportsType.accessed, label: 'REPORT_MANAGER_SELECT_2_ITEM_4' },
    { value: PasswordReportsType.overridingVaultPolicy, label: 'REPORT_MANAGER_SELECT_2_ITEM_5' }
];

export const vaultReportsOptions: any[] = [
    { value: VaultReportsType.createdRecently, label: 'REPORT_MANAGER_SELECT_3_ITEM_1' },
    { value: VaultReportsType.changedRecently, label: 'REPORT_MANAGER_SELECT_3_ITEM_2' },
    { value: VaultReportsType.exportedRecently, label: 'REPORT_MANAGER_SELECT_3_ITEM_3'},
    { value: VaultReportsType.grantedPermissions, label: 'REPORT_MANAGER_SELECT_3_ITEM_4' }
];


export const federationTypeOptions: any[] = [
    { value: MODULE_NAME.msolModule, label: 'MSOL_USE_MICROSOFT_ONLINE_OPTION' },
    { value: MODULE_NAME.graphModule, label: 'MSOL_USE_MICROSOFT_GRAPH_OPTION' }
];

export const tenantTypeOptions: any[] = [
    { value: TenantTypes.mme, label: 'MME' },
    { value: TenantTypes.msp, label: 'MSP' }
];

export const tenantBetas = {
    PasswordServer: 'ENABLE_PASSWORD_SERVER',
    HideEolBanner: 'HIDE_EOL_BANNER'
}